import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import * as React from 'react';
import { Link } from 'react-router-dom'; 

function DrawerItem({ text, Icon, to }) { 
  return (
    <ListItemButton component={Link} to={to}> 
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <ListItemText primary={text} />
    </ListItemButton>
  );
}

export default DrawerItem;